import { z } from "zod";

export const catalogSearchSchema = z.object({
	/** Old links to the Sources tab, which is now its own page; the route redirects them. */
	tab: z.enum(["products", "sources"]).optional(),
	/** Coerced: the router reads a pasted ?q=5449000000996 (a barcode) as a number. */
	q: z.coerce.string().optional(),
	dept: z.string().optional(),
	store: z.string().optional(),
	stock: z.enum(["in", "out"]).optional(),
	barcode: z.enum(["with", "without"]).optional(),
	status: z.enum(["active", "inactive"]).optional(),
	enrichment: z.enum(["missing", "overridden", "not_embedded"]).optional(),
	sort: z.enum(["title", "updated"]).optional(),
	page: z.number().int().min(1).optional(),
	/** Product open in the detail sheet. */
	product: z.string().optional(),
	/** Carried to the Sources page by the same redirect. */
	run: z.string().optional(),
});
export type CatalogSearch = z.infer<typeof catalogSearchSchema>;

export function productListInput(organizationId: string, s: CatalogSearch) {
	return {
		organizationId,
		...(s.q ? { q: s.q } : {}),
		...(s.dept ? { department: s.dept } : {}),
		...(s.store ? { storeId: s.store } : {}),
		...(s.stock ? { stock: s.stock } : {}),
		...(s.barcode ? { barcode: s.barcode } : {}),
		...(s.status ? { status: s.status } : {}),
		...(s.enrichment ? { enrichment: s.enrichment } : {}),
		...(s.sort ? { sort: s.sort } : {}),
		...(s.page ? { page: s.page } : {}),
	};
}

export const searchTesterSchema = z.object({
	/** Coerced: the router reads a pasted ?q=5449000000996 (a barcode) as a number. */
	q: z.coerce.string().optional(),
	store: z.string().optional(),
	dept: z.string().optional(),
	max: z.number().positive().optional(),
	instock: z.boolean().optional(),
	k: z.number().int().min(1).max(50).optional(),
	/** Product being explained for the current query. */
	explain: z.string().optional(),
});
export type SearchTesterSearch = z.infer<typeof searchTesterSchema>;

export function searchTestInput(organizationId: string, s: SearchTesterSearch) {
	return {
		organizationId,
		query: s.q ?? "",
		...(s.store ? { storeId: s.store } : {}),
		...(s.dept ? { department: s.dept } : {}),
		...(s.max ? { maxPrice: s.max } : {}),
		...(s.instock ? { inStockOnly: true } : {}),
		...(s.k ? { k: s.k } : {}),
	};
}
